// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a85ccae7","455":"d61ef033"}[chunkId] + ".chunk.js";
};